import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-current-detail-template',
  templateUrl: './current-detail-template.component.html',
  styleUrls: ['./current-detail-template.component.less']
})
export class CurrentDetailTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
